export const SECURITY_CODE_DESCRIPTIONS = {
	DR: "Depository Receipts",
	EQS: "Equity Shares",
	ETC: "Exchange Traded Commodities",
	ETF: "Exchange Traded Fund",
};
